module.exports = __webpack_public_path__ + "img/数景云平台2.82a6c5bb.jpg";